import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import PopularPlace from './../models/PopularPlace';
import { getDummyData } from './../utils/commonUtils';
import Config from "./../constants/Config";

export function getPopularPlaces(params) {
    return new ApiService({
        endpoint: Urls.POPULAR_PLACE_LIST,
        params: params,
        baseURL: Config.API_HOTEL,
        parser: dataParser,
    }).get();
}

export function getPopularPlaceDetail(id) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.POPULAR_PLACE_DETAIL,
        endpointParams: { id },
        parser: (data) => new PopularPlace(data.popularPlace),
    }).get();
}

export function createPopularPlace(popularPlace) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.POPULAR_PLACE_CREATE,
        parser: (data) => new PopularPlace(data.popularPlace),
    }).post({popularPlace: popularPlace.export()});
}

export function updatePopularPlace(popularPlace) {
    return new ApiService({
        baseURL: Config.API_HOTEL,
        endpoint: Urls.POPULAR_PLACE_DETAIL,
        endpointParams: { id: popularPlace.id },
        parser: (data) => new PopularPlace(data.popularPlace),
    }).put({popularPlace: popularPlace.export()});
}


const dataParser = (data) => ({
    dataList: (data.popularPlaces || []).map(item => new PopularPlace(item)),
    pageIndex: Math.floor(data.offset/data.limit) + 1, 
    pageSize: data.limit, 
    totalCount: data.total
});
const dataItemParser = (data) => new PopularPlace(data)
const getDummy = (pageSize = 10, pageIndex = 1) => {
    const getItem = (i) => new PopularPlace({
        id: i + 1,
        order: i + 1, 
        name: 'HOT NHẤT BALI | Bali SWING',
        averagePrice: 500000,
        numberOfVacancies: i + 1,
        isActive: i%2 === 0,
        image: ['placeimg.com/300/300/fish']
    });
    const result = getDummyData(pageSize, pageIndex, getItem);
    return { ...result, dataList: result.data };
}
const getDummyItem = (pageSize = 10, pageIndex = 1) => new PopularPlace({
    id: 2,
    order: 2,
    numberOfVacancies: 100,
    place: 'HOT NHẤT BALI | Bali SWING',
    averagePrice: 5000000,
    isActive: true,
    image: ['placeimg.com/300/300/fish']
});

